// extracted by mini-css-extract-plugin
module.exports = {"header":"TableHeader_header__2BGv0","cell":"TableHeader_cell__39G9V","cellMobile":"TableHeader_cellMobile__3-m5c","text":"TableHeader_text__3wK4u"};